import React from "react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";
import { CONDITION_MULTIPLIERS, CONDITION_LABELS } from "../lib/conditions";

export default function CardCopiesPanel({ card, format, onUpdate }) {
  const copies = card.copy_conditions || [];

  const setCopy = (i, value) => {
    const next = [...copies];
    next[i] = value;
    onUpdate(next);
  };

  return (
    <div data-testid="card-copies-panel" className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-zinc-500">Your copies ({copies.length}) — condition per copy</span>
        <button
          data-testid="merge-copies-button"
          onClick={() => onUpdate(null)}
          className="text-[11px] text-[#A78BFA] hover:text-white transition-colors"
          title="All copies take Copy 1's condition"
        >
          Stack as one condition
        </button>
      </div>
      {copies.map((cond, i) => (
        <div key={i} data-testid={`card-copy-row-${i}`} className="flex items-center justify-between gap-3 bg-black/40 border border-white/10 rounded-lg px-3 py-2">
          <span className="text-xs text-zinc-400 font-mono-plex shrink-0">Copy {i + 1}</span>
          <Select value={cond} onValueChange={(v) => setCopy(i, v)}>
            <SelectTrigger data-testid={`copy-condition-select-${i}`} className="h-8 w-[170px] bg-transparent border-white/10 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {Object.entries(CONDITION_LABELS).map(([value, label]) => (
                <SelectItem key={value} value={value}>{label} ({value})</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <span data-testid={`copy-value-${i}`} className="text-xs font-mono-plex text-[#A78BFA] w-20 text-right">
            {card.base_price_nm != null ? format(card.base_price_nm * (CONDITION_MULTIPLIERS[cond] ?? 1)) : "—"}
          </span>
        </div>
      ))}
    </div>
  );
}
